import React, { Component } from 'react';
import successLogo from './../../../../../statics/img/esaypaisa/success.svg';
import failLogo from './../../../../../statics/img/esaypaisa/fail.svg';
import pendingLogo from './../../../../../statics/img/esaypaisa/pending.svg';
import './Nift.css';

class NiftStatus extends Component {
    
    componentDidMount (){
        setTimeout(()=>{
            window.location.href = this.props.redirection_url;
        },3000)
    }

    renderSuccess = () => (
        <div>
            <img src={successLogo} />
            <h4 className="success">Payment successful</h4>
            <p>Thank you for using NIFT.</p>
        </div>
    )

    renderFail = () => (
        <div>
            <img src={failLogo} />
            <h4 className="fail">Payment failed</h4>
            <p>{this.props.status_message ? this.props.status_message : "Insufficient funds."}</p>
        </div>
    )

    renderPending = () => (
        <div>
            <img src={pendingLogo} />
            <h4 className="pending">Payment pending</h4>
            <p>Thank you for using NIFT.</p>
            <p>Transaction not confirmed yet by the payment gateway.</p>
        </div>
    )

    render() {
        return (
            <div className="nift_status">
                {this.props.nift_status == "success" && this.renderSuccess()}
                {this.props.nift_status == "fail" && this.renderFail()}
                {this.props.nift_status == "pending" && this.renderPending()}
            </div>
        )
    }
}
export default NiftStatus;